import { Outlet } from 'react-router';

export const AuthLayout = () => (
  <div className="flex h-screen flex-row items-center justify-center">
    <Outlet />
  </div>
);
